<template>
  <div>
    <template v-if="init">
      <v-card-title class="justify-center text-h5">
        {{ $t("productConfigurationsLabel") }}
      </v-card-title>

      <ProductConfigurationsTable
        v-bind:companyId="parseInt(companyId)"
        v-bind:userId="parseInt(userId)"
        v-bind:canAddNew="canAddNew"
        v-bind:canEdit="canEdit"
        v-bind:getByUser="getByUser"
        v-bind:getByCompany="getByCompany"
        v-bind:includeAffiliates="includeAffiliates"
      />
    </template>
  </div>
</template>

<script>
import ProductConfigurationsTable from "../components/ProductConfigurationsTable";
import UserTypes from "../auth/userTypes";
export default {
  data() {
    return {
      init: false,
      companyId: 0,
      userId: 0,
      canAddNew: false,
      canEdit: false,
      getByUser: false,
      getByCompany: false,
      includeAffiliates: false,
    };
  },
  components: {
    ProductConfigurationsTable,
  },
  methods: {
    initProductConfigurationsTable() {
      this.init = true;
      var userType = this.$store.state.user.userType;

      if (userType == UserTypes.WertheimAdministrator) {
        this.companyId = this.$store.state.user.companyId;
        (this.userId = this.$store.state.user.userId),
          (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = false),
          (this.getByCompany = false),
          (this.includeAffiliates = false);
      }
      if (userType == UserTypes.WertheimSales) {
        this.companyId = this.$store.state.user.companyId;
        this.userId = this.$store.state.user.userId;
        (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = false),
          (this.getByCompany = false),
          (this.includeAffiliates = false);
      }
      if (userType == UserTypes.SalesPartnershipAdmin) {
        this.companyId = this.$store.state.user.companyId;
        this.userId = this.$store.state.user.userId;
        (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = false),
          (this.getByCompany = true),
          (this.includeAffiliates = true);
      }
      if (userType == UserTypes.SalesPartnershipSales) {
        this.companyId = this.$store.state.user.companyId;
        this.userId = this.$store.state.user.userId;
        (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = true),
          (this.getByCompany = false),
          (this.includeAffiliates = false);
      }
      if (userType == UserTypes.SalesPartnershipProductConfigurator) {
        this.companyId = this.$store.state.user.companyId;
        this.userId = this.$store.state.user.userId;
        (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = true),
          (this.getByCompany = false),
          (this.includeAffiliates = false);
      }
      if (userType == UserTypes.AffiliatePartnershipSales) {
        this.companyId = this.$store.state.user.companyId;
        this.userId = this.$store.state.user.userId;
        (this.canAddNew = true),
          (this.canEdit = true),
          (this.getByUser = true),
          (this.getByCompany = false),
          (this.includeAffiliates = false);
      }
    },
  },
  mounted() {
    this.initProductConfigurationsTable();
  },
};
</script>

<style lang="scss" scoped>
</style>